/**
 * pharmacyselfservice.js: Feature level module
 * @description This module is used for : 
 * 										1. Displaying Marketing Content
 */

define([], function() {
	if (typeof window.COSTCO == 'undefined') {
		window.COSTCO = new Object();
	}

	var PharmacySelfService = {



/** createCMPPCarousels used for created the carousels - desktop and mobile - displaying product tiles new to CMPP 
		 * NOTE: The creation of two carousels for desktop and mobile
		*/
		createCMPPCarousels: function(){
			$('#new-to-cmpp').show();
			//Desktop view
			COSTCO.util.carousel('#new-to-cmpp-products-carousel-desktop',{
				dots: true,
				arrows: true,
				prevArrow: '<button id="cmppPrevArrowDesktop" class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button id="cmppNextArrowDesktop" class="slick-next" aria-label="Next" type="button">Next</button>',
				moveArrowstoDots: true,
				slidesToShow: 4,
				slidesToScroll: 4,
				autoplay: false,
				infinite: false,
				lazyLoad: 'ondemand',
				owlDotLabel: messages.CMPP_NEW_PRODUCTS,
			}, {nextLabel: messages.CMPP_CAROUSEL_NEXT, prevLabel: messages.CMPP_CAROUSEL_PREVIOUS});
			//Mobile view
			COSTCO.util.carousel('#new-to-cmpp-products-carousel-mobile',{
				dots: true,
				arrows: true,
				prevArrow: '<button id="cmppPrevArrowMobile" class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button id="cmppNextArrowMobile" class="slick-next" aria-label="Next" type="button">Next</button>',
				moveArrowstoDots: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				rows: 2,
				autoplay: false,
				infinite: false,
				lazyLoad: 'ondemand',
				owlDotLabel: messages.CMPP_NEW_PRODUCTS,
			}, {nextLabel: messages.CMPP_CAROUSEL_NEXT, prevLabel: messages.CMPP_CAROUSEL_PREVIOUS});
			PharmacySelfService.moveIndicators();
		},
		/** moveArrowstoIndicators used for moving the carousel arrows - created from the 
		 * carousel slick.js initialisation from function 'createCMPPCarousels' - to element where the dot
		 * indicators hold in order to present the arrows in the same area as the indicators as requested by business*/
		moveIndicators: function(){
			// Desktop view
			$('#new-to-cmpp-products-carousel-desktop>ul.slick-dots').appendTo('#cmpp-carousel-indicators-desktop');
			$('#cmppPrevArrowDesktop').prependTo($('#cmpp-carousel-indicators-desktop'));
			$('#cmppNextArrowDesktop').appendTo($('#cmpp-carousel-indicators-desktop'));
			// Mobile view
			$('#new-to-cmpp-products-carousel-mobile>ul.slick-dots').appendTo('#cmpp-carousel-indicators-mobile');
			$('#cmppPrevArrowMobile').prependTo($('#cmpp-carousel-indicators-mobile'));
			$('#cmppNextArrowMobile').appendTo($('#cmpp-carousel-indicators-mobile'));
		},


		/**
		 * Get the description of the drug - used to populate the strengthDescription inside the CMPP carousel tiles
		 */
		getDrugPackageFormDescription: function(showPackageIndicatorParam, drugPackageParam, drugFormParam, drugStrengthParam, drugQuantityParam, substitutionBrandDrugs) {
			/**
			 * drugPackageOrFormParam is the string being built upon that will populate the 'strengthDescription' of the 
			 * drug tile inside the CMPP carousel. Goes through series of checks to determine what gets added to the string.
			 * At the end of the function, drugPackageOrFormParam is returned.
			 */
			let drugPackageOrFormParam = '';
			// if drug is generic version of particular drug, add the label 'Generic of' to the string describing the brand it substitutes
			if (substitutionBrandDrugs != null || substitutionBrandDrugs != undefined){
				let genericBrandStr = 'Generic of ';
				for(let i = 0; i < substitutionBrandDrugs.length; i++) {
					genericBrandStr += substitutionBrandDrugs[i] + ', ';
				}
				drugPackageOrFormParam += genericBrandStr;
			}
			/**
			 * 'showPackageIndicatorParam' is boolean used to check if adding the package to the description is appropriate
			 * otherwise, skip appending the package description to the string
			 */
			if(showPackageIndicatorParam){
				if(drugFormParam != 'Miscellaneous'){
					drugPackageOrFormParam += drugFormParam + ", ";
				}
				drugPackageOrFormParam += drugPackageParam;
				if($.trim(drugStrengthParam) != ''){
					drugPackageOrFormParam += ", " + drugStrengthParam;
				}
			}else{
				if($.trim(drugStrengthParam) != ''){
					drugPackageOrFormParam += drugStrengthParam + ", ";
				}
				drugPackageOrFormParam += drugQuantityParam + " " + drugFormParam.toLowerCase();
				if((drugFormParam == 'Tablet' || drugFormParam == 'Capsule') && drugQuantityParam > 1){
					drugPackageOrFormParam += "s";
				}
			}
			/**
			 * return 'drugPackageOrFormParam' to be used to populate 'strengthDescription'
			 * inside drug tile template 'tmpl_new_to_cmpp_carousel_product_display'
			 */
			return drugPackageOrFormParam;
		},

		/**
		 * getFormularyPetMedicationsProductsById is a method is used for displaying formulary products for the Pet Medications.
		 * This method is invoke by the primary method getFormularyPetSavingsDrugAuthDetails
		 * @param : formularyId
		 */
		getFormularyPetMedicationsProductsById: function(data){
			let remark_html = '';
			var object = data;
			remark_html += COSTCO.util.tmpl('tmpl_drug_pet_formulary_details_heading', {});
			for (var i in object.items){
				var drugStrengthStr = (!(/^ *$/.test(object.items[i].drugAndStrength))) ? " - " + object.items[i].drugAndStrength : "" ;
				remark_html += COSTCO.util.tmpl('templ_formulary_pet_medications_products_display', {
                drugName: object.items[i].drugName,
                dosageForm: object.items[i].dosageForm,
                quantity: object.items[i].quantity,
                drugAndStrength : drugStrengthStr,
                drugPrice: PharmacySelfService.populateMinumumPrice(object.items[i]),
              });
			}
			remark_html = remark_html+'</table>';
			$('#div_formulary_pet_medications_products_display').html(remark_html);
		},

		/**
		 * populateMinumumPrice is a method is used for return the minimum price from the list of prices.
		 * @param : JSON object
		 */
		populateMinumumPrice : function(object){
			let priceListarr = [];
			let minPrice = null;
			object.networkPriceInfo.forEach(function(storeObj, i){
				priceListarr.push(storeObj.cmppPrice);
			});
			minPrice = Math.min.apply(null, priceListarr);
			return minPrice;
		},
	};
	window.COSTCO.PharmacySelfService = PharmacySelfService
});



// WEBPACK FOOTER //
// ./js/cmpp/pharmacyselfservice.js